module.exports = __webpack_public_path__ + "static/img/48-2.dfaf014.png";